export const state = () => ({
  orgId: null,
  views: {},
})
